import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { FormGroup, FormHelperText } from '@mui/material';
import * as styles from './styles.css';
import { IComponent, IOption } from '../../../interfaces';
import { useProps } from '../../../hooks/use-props';

export interface IRadioButtonProps {
  id: string;
}

export interface IRadioButtonAtom extends IComponent {
  value: IOption;
  error?: string;
}

const useRadioButton = (id: string) => {
  const { props, addAnswer } = useProps<IRadioButtonAtom>({ id, initial_state: '' });
  return {
    props,
    setValue: (answer?: IOption) => {
      if (answer) {
        addAnswer({ answer: answer.id });
      }
    },
  };
};

const RadioButton = ({ id }: IRadioButtonProps) => {
  const {
    props: { show, error, required, value, label, options, variant },
    setValue,
  } = useRadioButton(id);
  if (!show) return null;
  return (
    <FormControl id={id} error={!!error} required={required} className={styles.root}>
      <FormLabel component="legend" className={styles.label}>
        <b>{label}</b>
        {variant && <span style={{ fontWeight: 400 }}>&nbsp;{variant}</span>}
      </FormLabel>
      <FormGroup>
        <RadioGroup
          value={value?.id?.toString() || value?.toString() || ''}
          onChange={(_event, newValue) => {
            const selectedOption = options?.find(
              (option) => option.id.toString() === newValue.toString(),
            );
            setValue(selectedOption);
          }}
        >
          {options &&
            options.map((option) => (
              <FormControlLabel
                key={option.id}
                value={option.id.toString()}
                id={`${id}-${option.id}`}
                control={<Radio />}
                label={option.label}
              />
            ))}
        </RadioGroup>
      </FormGroup>
      {error && <FormHelperText id={`${id}-error`}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default RadioButton;
